// @ts-check
import React from 'react';
import DownloadIcon from '~/templates/components/DownloadIcon';
import GatsbyBackgroundImage from '~/templates/components/images/GatsbyBackgroundImage';
import { getImageDisplayOptions } from '../utils/ImageHelper';

import './ThumbnailImageDownloadSection.scss';

/**
 * @typedef ThumbnailImageDownloadSectionProps
 * @property {string} downloadIconContent
 * @property {import('../CSTypes').BynderImageOptions} [option]
 */
/** @type {import('~/types/React').ReactFC<ThumbnailImageDownloadSectionProps>} */
const ThumbnailImageDownloadSection = ({ downloadIconContent, option }) => {
	// Remove the transforms, and give full quality.
	const downloadOpts = Object.assign({}, option, { transforms: [] });
	const bgOpts = getImageDisplayOptions(downloadOpts, 100);
	if (!bgOpts?.url) {
		return null;
	}

	return (
		<a
			className="thumbnail-image-download-section col-lg-4 col-md-6 col-sm-12"
			target="_blank"
			rel="noreferrer"
			href={bgOpts.url}
			download={true}
		>
			<GatsbyBackgroundImage className="thumbnail-image-background" option={option}>
				<DownloadIcon className="the-icon" iconContent={downloadIconContent} />
			</GatsbyBackgroundImage>
		</a>
	);
};

export default ThumbnailImageDownloadSection;
